// extracted by mini-css-extract-plugin
module.exports = {"preloader":"_31g80","enabled":"b3QJR","semi-rotate":"pcCXj","semiRotate":"pcCXj","inner-rotate":"_3KzRa","innerRotate":"_3KzRa","white":"_1V7IX","dark":"Uvopv"};